import { render, staticRenderFns } from "./webIcon.vue?vue&type=template&id=63e9ef2a&"
import script from "./webIcon.vue?vue&type=script&lang=js&"
export * from "./webIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports